import React, { useState } from 'react';
import '../styles/ReachUs.css';
import Footer from '../components/Footer';

const ReachUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const showNotification = (message, type = 'info') => {
    const existingNotifications = document.querySelectorAll('.notification');
    existingNotifications.forEach(notification => notification.remove());
    
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.innerHTML = `
      <div class="notification-content">
        <span class="notification-message">${message}</span>
        <button class="notification-close">&times;</button>
      </div>
    `;
    
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#3b82f6'};
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.15);
      z-index: 10000;
      max-width: 400px;
      animation: slideInRight 0.3s ease;
      font-family: 'Inter', sans-serif;
      backdrop-filter: blur(10px);
    `;
    
    document.body.appendChild(notification);
    
    const closeBtn = notification.querySelector('.notification-close');
    closeBtn.addEventListener('click', () => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    });
    
    setTimeout(() => {
      if (notification.parentNode) {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }
    }, 5000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      showNotification('Please fill in all fields', 'error');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showNotification('Please enter a valid email address', 'error');
      return;
    }

    setIsSubmitting(true);

    // Create WhatsApp message starting with greeting and including form data
    const whatsappMessage = `Hi Ark Moving Images,

Name: ${formData.name}
Email: ${formData.email}

Message: ${formData.message}`;

    const encodedMessage = encodeURIComponent(whatsappMessage);
    // Use the phone number from .env file
    const whatsappNumber = (process.env.REACT_APP_WHATSAPP || process.env.REACT_APP_PHONE_NUMBER || '').toString();
    const whatsappURL = whatsappNumber ? `https://wa.me/91${whatsappNumber}?text=${encodedMessage}` : '#';

    showNotification('🚀 Opening WhatsApp chat...', 'info');

    setTimeout(() => {
      const whatsappWindow = window.open(whatsappURL, '_blank');
      
      if (whatsappWindow) {
        // Save form data before clearing
        const savedFormData = { ...formData };
        
        setFormData({ name: '', email: '', message: '' });
        setIsSubmitting(false);
        
        setTimeout(() => {
          showNotification('✅ WhatsApp chat opened! Click send to start your conversation.', 'success');
          
          // Optional: Track that user started a chat
          console.log('Chat initiated for:', savedFormData.name, savedFormData.email);
        }, 500);
      } else {
        setIsSubmitting(false);
        showNotification('⚠️ Popup blocked! Please allow popups or try the WhatsApp button below.', 'error');
      }
    }, 1500);
  };

  return (
    <div className="reachus-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="hero-content">
          <div className="container">
            <h1 className="hero-title">Reach Out to Us</h1>
            <p className="hero-subtitle">
              Let's create something extraordinary together. Get in touch with our team of creative professionals.
            </p>
            <div className="hero-buttons">
              <a href="#contact-form" className="btn btn-primary">Get Started</a>
              <a href="#locations" className="btn btn-outline-light">Our Locations</a>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations Section */}
      <section id="locations" className="locations-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Offices</h2>
            <p className="section-subtitle">
              Visit us at any of our strategically located offices
            </p>
          </div>

          <div className="location-cards">
            <div className="location-card">
              <div className="location-content">
                <h3>Main Office</h3>
                <p className="location-address">
                  <i className="fas fa-map-marker-alt"></i>
                  {process.env.REACT_APP_ADDRESS || ''}
                </p>
                <div className="location-details">
                  <p><i className="fas fa-clock"></i> Mon-Fri: 9:00 AM - 6:00 PM</p>
                  <p><i className="fas fa-phone"></i> {process.env.REACT_APP_PHONE_NUMBER ? `+91 ${process.env.REACT_APP_PHONE_NUMBER}` : ''}</p>
                  <p><i className="fas fa-envelope"></i> {process.env.REACT_APP_EMAIL || ''}</p>
                </div>
                <a href={(process.env.REACT_APP_ADDRESS) ? `https://maps.google.com/?q=${encodeURIComponent(process.env.REACT_APP_ADDRESS)}` : '#'} 
                   target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">Get Directions</a>
              </div>
            </div>

            <div className="location-card">
              <div className="location-content">
                <h3>Studio Office</h3>
                <p className="location-address">
                  <i className="fas fa-map-marker-alt"></i>
                  {process.env.REACT_APP_ADDRESS || ''}
                </p>
                <div className="location-details">
                  <p><i className="fas fa-clock"></i> Mon-Sat: 8:00 AM - 8:00 PM</p>
                  <p><i className="fas fa-phone"></i> {process.env.REACT_APP_SECOND_NUMBER ? `+91 ${process.env.REACT_APP_SECOND_NUMBER}` : ''}</p>
                  <p><i className="fas fa-envelope"></i> {process.env.REACT_APP_EMAIL || ''}</p>
                </div>
                <a href={(process.env.REACT_APP_ADDRESS) ? `https://maps.google.com/?q=${encodeURIComponent(process.env.REACT_APP_ADDRESS)}` : '#'} 
                   target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">Get Directions</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Contact Section */}
      <section className="enhanced-contact-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ready to Start Your Project?</h2>
            <p className="section-subtitle">
              Let's discuss how we can bring your vision to life
            </p>
          </div>

          <div className="contact-info-cards">
            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Visit Us</h3>
              <p>{process.env.REACT_APP_ADDRESS || ''}</p>
              <a href={(process.env.REACT_APP_ADDRESS) ? `https://maps.google.com/?q=${encodeURIComponent(process.env.REACT_APP_ADDRESS)}` : '#'} 
                 target="_blank" rel="noopener noreferrer" className="contact-link">Get Directions</a>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3>Call Us</h3>
              <p>
                {process.env.REACT_APP_PHONE_NUMBER ? `+91 ${process.env.REACT_APP_PHONE_NUMBER}` : ''}
                {process.env.REACT_APP_SECOND_NUMBER ? <><br />{`+91 ${process.env.REACT_APP_SECOND_NUMBER}`}</> : ''}
              </p>
              <a href={process.env.REACT_APP_PHONE_NUMBER ? `tel:+91${process.env.REACT_APP_PHONE_NUMBER}` : '#'} className="contact-link">Call Now</a>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>Email Us</h3>
              <p>{process.env.REACT_APP_EMAIL || ''}</p>
              <a href={(process.env.REACT_APP_EMAIL) ? `mailto:${process.env.REACT_APP_EMAIL}` : '#'} className="contact-link">Send Email</a>
            </div>
          </div>

          <div className="cta-buttons">
            <a href="#contact-form" className="btn btn-primary">
              <i className="fas fa-paper-plane"></i>
              Start Project
            </a>
            <a href="/about" className="btn btn-outline-primary">
              <i className="fas fa-info-circle"></i>
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="digital-contact-section">
        <div className="digital-contact-background"></div>
        <div className="digital-contact-overlay"></div>
        <div className="digital-contact-container">
          <div className="digital-contact-left">
              <div className="digital-contact-header">
              <span className="digital-contact-mini-heading">CONTACT US</span>
              <h2 className="digital-contact-heading">Contact For Any Kind Of Information</h2>
              <p className="digital-contact-desc">Ready to transform your digital presence? Get in touch with our expert team for personalized solutions that drive results. Fill out the form below and we'll start a WhatsApp chat to discuss your project!</p>
              <div style={{ marginTop: '20px', padding: '12px 20px', background: 'rgba(245, 158, 11, 0.1)', borderRadius: '10px', border: '1px solid rgba(245, 158, 11, 0.3)' }}>
                <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>
                  💡 Tip: After submitting, click "Send" in the WhatsApp window to start your conversation!
                </p>
              </div>
            </div>
            <form className="digital-contact-form" onSubmit={handleSubmit}>
              <div className="digital-form-group">
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your Name*" 
                  required 
                  className="digital-contact-input"
                />
                <div className="digital-input-focus-effect"></div>
              </div>
              <div className="digital-form-group">
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Your Email*" 
                  required 
                  className="digital-contact-input"
                />
                <div className="digital-input-focus-effect"></div>
              </div>
              <div className="digital-form-group">
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Your Message*" 
                  required 
                  className="digital-contact-input" 
                  rows="4"
                ></textarea>
                <div className="digital-input-focus-effect"></div>
              </div>
              <button type="submit" className="digital-contact-btn" disabled={isSubmitting}>
                <span>
                  {isSubmitting ? (
                    <>🔄 PREPARING CHAT...</>
                  ) : (
                    <>📱 START CHAT ON WHATSAPP</>
                  )}
                </span>
                <div className="digital-btn-glow"></div>
              </button>
            </form>
          </div>
          <div className="digital-contact-right">
            <div className="digital-contact-card">
              <div className="digital-contact-info-item">
                <div className="digital-contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="digital-contact-info-content">
                  <h3>Our Address</h3>
                  <p>{process.env.REACT_APP_ADDRESS || ''}</p>
                </div>
              </div>
              <div className="digital-contact-info-item">
                <div className="digital-contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="digital-contact-info-content">
                  <h3>Phone Numbers</h3>
                  <p>
                    {process.env.REACT_APP_PHONE_NUMBER ? `Phone : +91 ${process.env.REACT_APP_PHONE_NUMBER}` : ''}
                    {process.env.REACT_APP_SECOND_NUMBER ? <><br />{`Mobile : +91 ${process.env.REACT_APP_SECOND_NUMBER}`}</> : ''}
                  </p>
                </div>
              </div>
              <div className="digital-contact-info-item">
                <div className="digital-contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="digital-contact-info-content">
                  <h3>Email Address</h3>
                  <p>{process.env.REACT_APP_EMAIL || process.env.EMAIL || ''}</p>
                </div>
              </div>
              <div className="digital-contact-social">
                <h3>Follow Us</h3>
                <div className="digital-social-links">
                  <a href="https://www.facebook.com/arkmovingimages" target="_blank" rel="noreferrer" className="digital-social-link" aria-label="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href={process.env.REACT_APP_INSTAGRAM || '#'} target="_blank" rel="noreferrer" className="digital-social-link" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/arkmovingimages" target="_blank" rel="noreferrer" className="digital-social-link" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://www.youtube.com/@arkmovingimages" target="_blank" rel="noreferrer" className="digital-social-link" aria-label="YouTube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href={(process.env.REACT_APP_WHATSAPP || process.env.REACT_APP_PHONE_NUMBER) ? `https://wa.me/91${process.env.REACT_APP_WHATSAPP || process.env.REACT_APP_PHONE_NUMBER}?text=${encodeURIComponent('Hi Ark Moving Images')}` : '#'} target="_blank" rel="noreferrer" className="digital-social-link" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReachUs;
